// import { Breadcrumbs, Typography, Button } from '@material-ui/core'
// import { ArrowBack  } from '@material-ui/icons'
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { alpha, useTheme } from "@mui/material/styles";
import { UpperCaseFirst } from "~/Services/Helpers";
import { style } from "./styles";
import { Breadcrumbs, Chip, GlobalStyles, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import { useIntl, FormattedMessage } from "react-intl";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import InventoryIcon from "@mui/icons-material/Inventory";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ReceiptIcon from "@mui/icons-material/Receipt";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ContactsIcon from "@mui/icons-material/Contacts";
import PeopleIcon from "@mui/icons-material/People";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DescriptionIcon from "@mui/icons-material/Description";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ListAltIcon from "@mui/icons-material/ListAlt";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import WarningIcon from "@mui/icons-material/Warning";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import PersonIcon from "@mui/icons-material/Person";
import SecurityIcon from "@mui/icons-material/Security";
import BalanceIcon from "@mui/icons-material/Balance";
import AssessmentIcon from "@mui/icons-material/Assessment";
import FolderSpecialIcon from "@mui/icons-material/FolderSpecial";
import StorageIcon from "@mui/icons-material/Storage";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import CardMembershipIcon from "@mui/icons-material/CardMembership";

const SubHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const app = useSelector((state) => state?.app?.app);
    const theme = useTheme();
    const intl = useIntl();
    const isRTL = app.direction === "rtl";
    const segments = location.pathname.split("/").filter(Boolean);

    // إعادة إنشاء navigation للحصول على الترجمات
    const navigation = React.useMemo(
        () => [
            { kind: "page", segment: "home", title: intl.formatMessage({ id: `header.homePage` }) },
            { kind: "page", segment: "home-page", title: intl.formatMessage({ id: `header.pos` }) },
            { kind: "page", segment: "material-selection", title: intl.formatMessage({ id: `header.materialSelection` }) },
            {
                kind: "page",
                segment: "products-you-want-to-sell-online",
                title: intl.formatMessage({ id: `header.ProductsYouWantToSellOnline` }),
            },
            { kind: "page", segment: "receipts", title: intl.formatMessage({ id: `header.receipts` }) },
            { kind: "page", segment: "salesmen", title: intl.formatMessage({ id: `header.salesmen` }) },
            { kind: "page", segment: "pharmacy", title: intl.formatMessage({ id: `header.pharmacy` }) },
            { kind: "page", segment: "orders-dist", title: intl.formatMessage({ id: `header.OrdersDistributor` }) },

            { kind: "page", segment: "warehouses", title: intl.formatMessage({ id: `header.warehouses` }) },
            { kind: "page", segment: "warehouse-orders", title: intl.formatMessage({ id: `header.warehouse-orders` }) },
            {
                kind: "group",
                segment: "accounts",
                title: intl.formatMessage({ id: `header.accounts` }),
                children: [
                    { segment: "acounts-directory", title: intl.formatMessage({ id: `header.directoryAcounts` }) },
                    { segment: "customer", title: intl.formatMessage({ id: `header.customer` }) },
                    { segment: "suppliers", title: intl.formatMessage({ id: `header.suppliers` }) },
                    { segment: "detailed-account-statement", title: intl.formatMessage({ id: `header.detailedAccountStatement` }) },
                    { segment: "total-account-statement", title: intl.formatMessage({ id: `header.TotalAccountStatement` }) },
                ],
            },
            { kind: "page", segment: "bills", title: intl.formatMessage({ id: `header.bills` }) },
            { kind: "page", segment: "bills/add-bill", title: intl.formatMessage({ id: `header.addBills` }) },
            { kind: "page", segment: "union-bills", title: intl.formatMessage({ id: `header.unionBills` }) },
            { kind: "page", segment: "accounting-transaction", title: intl.formatMessage({ id: `header.AccountingTransaction` }) },
            {
                kind: "page",
                segment: "open-accounting-transaction",
                title: intl.formatMessage({ id: `header.openAccountingTransaction` }),
            },
            { kind: "page", segment: "required-materials", title: intl.formatMessage({ id: `header.RequiredMaterials` }) },
            {
                kind: "page",
                segment: "closing-expire-date-item",
                title: intl.formatMessage({ id: `header.ClosingExpireDateItem` }),
            },
            { kind: "page", segment: "items-transactions", title: intl.formatMessage({ id: `header.ItemsTransactions` }) },
            { kind: "page", segment: "material-inventory", title: intl.formatMessage({ id: `header.MaterialInventory` }) },
            { kind: "page", segment: "profit-report", title: intl.formatMessage({ id: `header.ProfitReport` }) },
            { kind: "page", segment: "openingm-erchandise", title: intl.formatMessage({ id: `header.OpeningMerchandise` }) },
            { kind: "page", segment: "users", title: intl.formatMessage({ id: `header.users` }) },
            { kind: "page", segment: "roles", title: intl.formatMessage({ id: `header.Roles` }) },
            { kind: "page", segment: "trial-balance", title: intl.formatMessage({ id: `header.TrialBalance` }) },
            { kind: "page", segment: "orders", title: intl.formatMessage({ id: `header.Orders` }) },
            { kind: "page", segment: "final-accounts", title: intl.formatMessage({ id: `header.FinalAccounts` }) },
            { kind: "page", segment: "special-materials", title: intl.formatMessage({ id: `header.SpecialMaterials` }) },
            { kind: "page", segment: "repository", title: intl.formatMessage({ id: `header.repository` }) },
            { kind: "page", segment: "currency", title: intl.formatMessage({ id: `header.currency` }) },
            { kind: "page", segment: "subscription", title: intl.formatMessage({ id: `header.subscription` }) },
        ],
        [intl]
    );

    // إنشاء خريطة مسطحة للبحث السريع
    const segmentMap = React.useMemo(() => {
        const map = new Map();
        const addToMap = (items) => {
            items.forEach((item) => {
                if (item.kind === "page" && item.segment) {
                    map.set(item.segment, item.title);
                } else if (item.kind === "group" && item.children) {
                    addToMap(item.children);
                }
            });
        };
        addToMap(navigation);
        return map;
    }, [navigation]);

    // دالة للحصول على ترجمة segment
    const getSegmentTitle = React.useCallback(
        (segment, allSegments, currentIndex) => {
            // البحث في الخريطة أولاً باستخدام الـ segment الفردي
            const translated = segmentMap.get(segment);
            if (translated) return translated;

            // إذا كان هناك مسار متداخل، جرب البحث بالمسار الكامل حتى هذه النقطة
            if (allSegments.length > 0) {
                const pathUpToCurrent = allSegments.slice(0, currentIndex + 1).join("/");
                const pathTranslated = segmentMap.get(pathUpToCurrent);
                if (pathTranslated) return pathTranslated;

                // جرب البحث بمسار كامل للصفحة الحالية
                const fullPath = allSegments.join("/");
                const fullPathTranslated = segmentMap.get(fullPath);
                if (fullPathTranslated) return fullPathTranslated;
            }

            // إذا لم تُوجد ترجمة، استخدم الاسم الافتراضي
            return UpperCaseFirst(segment.replace(/-/g, " "));
        },
        [segmentMap]
    );

    const crumbs = React.useMemo(() => {
        if (segments.length === 0) return null;
        return segments.map((segment, index) => {
            const to = `/${segments.slice(0, index + 1).join("/")}`;
            const isLast = index === segments.length - 1;
            const label = getSegmentTitle(segment, segments, index);
            return (
                <Chip
                    key={to}
                    label={label}
                    variant={isLast ? "filled" : "outlined"}
                    color={isLast ? "primary" : "default"}
                    onClick={!isLast ? () => navigate(to) : undefined}
                    clickable={!isLast}
                    sx={{
                        borderRadius: 999,
                        borderColor: alpha(theme.palette.text.primary, 0.15),
                        bgcolor: isLast ? alpha(theme.palette.primary.main, 0.15) : "transparent",
                        color: isLast ? theme.palette.primary.main : theme.palette.text.secondary,
                    }}
                />
            );
        });
    }, [segments, navigate, theme.palette.primary.main, theme.palette.text.primary, getSegmentTitle]);

    return (
        <>
            <GlobalStyles styles={style} />
            <Stack className="subheader-shell" sx={{ flexDirection: "row" }} /* direction={{ xs: "row", sm: "row" }} */ spacing={2} alignItems="center">
                <Stack direction="row" spacing={1}>
                    <Tooltip title={<FormattedMessage id="subheader.back" defaultMessage="عودة" />}>
                        <IconButton onClick={() => navigate(-1)} size="small">
                            {isRTL ? <ArrowForwardIosIcon fontSize="inherit" /> : <ArrowBackIosNewIcon fontSize="inherit" />}
                        </IconButton>
                    </Tooltip>
                    {/* <Tooltip title="التالي">
                        <IconButton onClick={() => navigate(1)} size="small">
                            {isRTL ? <ArrowBackIosNewIcon fontSize="inherit" /> : <ArrowForwardIosIcon fontSize="inherit" />}
                        </IconButton>
                    </Tooltip> */}
                </Stack>
                <Stack spacing={0.5} sx={{ width: "100%", mt: "0px !important" }}>
                    {/* <Typography variant="caption" color="text.secondary">
                        <FormattedMessage id="subheader.currentSequence" defaultMessage="التسلسل الحالي" />
                    </Typography> */}
                    <Breadcrumbs maxItems={4} separator="•" aria-label="breadcrumb" className="breadcrumb-track">
                        <Chip
                            icon={<HomeRoundedIcon />}
                            label={<FormattedMessage id="subheader.home" defaultMessage="الرئيسية" />}
                            size="small"
                            onClick={() => navigate("/home")}
                            sx={{ borderRadius: 999 }}
                        />
                        {crumbs}
                    </Breadcrumbs>
                </Stack>
            </Stack>
        </>
    );
};

export default SubHeader;

// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Breadcrumbs, Button, Typography } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// const SubHeader = () => {
//     const navigate = useNavigate();
//     const location = useLocation();

//     // لتخزين المسار السابق
//     const previousPathRef = useRef(null);
//     const [previousPage, setPreviousPage] = useState("");

//     useEffect(() => {
//         // عندما يتغير المسار، نقوم بتحديث المسار السابق
//         if (previousPathRef.current !== location.pathname) {
//             const pathSegments = previousPathRef.current?.split("/") || [];
//             const lastSegment = pathSegments[pathSegments.length - 1];
//             console.log('pathSegments', pathSegments)
//             setPreviousPage(lastSegment || "home-page");
//             previousPathRef.current = location.pathname; // تحديث المسار السابق
//         }
//     }, [location]);

//     // تحويل النص ليبدأ بحرف كبير
//     const capitalizeFirstLetter = (string) =>
//         string ? string.charAt(0).toUpperCase() + string.slice(1) : "";

//     return (
//         <div style={{ display: "flex", alignItems: "center" }}>
//             {/* زر الرجوع */}
//             <Button
//                 startIcon={<ArrowBackIcon />}
//                 onClick={() => navigate(-1)} // العودة إلى الصفحة السابقة
//                 sx={{
//                     minWidth: 0,
//                     height: "30px",
//                     width: "30px",
//                     marginRight: "8px",
//                 }}
//             />

//             {/* اسم الصفحة السابقة */}
//             <Breadcrumbs aria-label="breadcrumb">
//                 <Typography
//                     sx={{ cursor: "pointer", textDecoration: "underline" }}
//                     onClick={() => navigate(capitalizeFirstLetter(previousPage))} // عند الضغط، العودة للصفحة السابقة
//                 >
//                     {capitalizeFirstLetter(previousPage).toLowerCase()}
//                 </Typography>
//             </Breadcrumbs>
//         </div>
//     );
// };

// export default SubHeader;
